import { useEffect, useState } from "react";
import { FolderKanban, MessageSquare, Quote, BarChart3, Wallet, FileText, Users, Trophy, Package } from "lucide-react";
import api from "../../lib/api";
import { Link } from "react-router-dom";

export default function AdminOverview() {
  const [counts, setCounts] = useState({});
  useEffect(() => {
    document.title = "Admin · Overview | Dutsen Kauna Foundation";
    (async () => {
      const [p, t, s, m, d, apps, ben, don, sel, fam] = await Promise.all([
        api.get("/projects?active_only=false").catch(() => ({ data: [] })),
        api.get("/testimonials").catch(() => ({ data: [] })),
        api.get("/impact-stats").catch(() => ({ data: [] })),
        api.get("/admin/contact-submissions").catch(() => ({ data: [] })),
        api.get("/admin/donation-intents").catch(() => ({ data: [] })),
        api.get("/admin/applications").catch(() => ({ data: [] })),
        api.get("/admin/beneficiaries").catch(() => ({ data: [] })),
        api.get("/admin/donors").catch(() => ({ data: [] })),
        api.get("/admin/empowerment/selections").catch(() => ({ data: [] })),
        api.get("/admin/family-support").catch(() => ({ data: [] })),
      ]);
      setCounts({
        applications: apps.data.length,
        beneficiaries: ben.data.length,
        donors: don.data.length,
        selections: sel.data.length,
        family: fam.data.length,
        projects: p.data.length,
        testimonials: t.data.length,
        impact: s.data.length,
        messages: m.data.length,
        donations: d.data.length,
      });
    })();
  }, []);

  const cards = [
    { to: "/admin/applications", label: "Applications", value: counts.applications, icon: FileText, hero: true },
    { to: "/admin/beneficiaries", label: "Beneficiaries", value: counts.beneficiaries, icon: Users, hero: true },
    { to: "/admin/donors", label: "Donors", value: counts.donors, icon: Wallet, hero: true },
    { to: "/admin/selection", label: "Selections run", value: counts.selections, icon: Trophy },
    { to: "/admin/family", label: "Family food", value: counts.family, icon: Package },
    { to: "/admin/projects", label: "Projects", value: counts.projects, icon: FolderKanban },
    { to: "/admin/testimonials", label: "Testimonials", value: counts.testimonials, icon: Quote },
    { to: "/admin/impact", label: "Impact stats", value: counts.impact, icon: BarChart3 },
    { to: "/admin/messages", label: "Contact messages", value: counts.messages, icon: MessageSquare },
    { to: "/admin/donations", label: "Legacy intents", value: counts.donations, icon: Wallet },
  ];

  return (
    <div data-testid="admin-overview">
      <h1 className="font-serif text-3xl text-[#0a0d12] font-bold mb-2">Welcome back.</h1>
      <p className="text-[#0a0d12]/60 mb-8">Manage the Foundation's programmes, applications and content from one place.</p>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <Link key={c.to} to={c.to} className={`rounded-xl p-6 hover:shadow-md transition ${c.hero ? "bg-[#155e3f] text-white ring-1 ring-[#d6aa43]/30" : "bg-white border border-black/5"}`} data-testid={`overview-${c.label.toLowerCase().split(" ")[0]}`}>
              <Icon className={c.hero ? "text-[#d6aa43] mb-3" : "text-[#d6aa43] mb-3"} size={20} />
              <div className={`font-serif text-3xl font-bold ${c.hero ? "text-[#d6aa43]" : "text-[#0a0d12]"}`}>{c.value ?? 0}</div>
              <div className={`text-xs uppercase tracking-[0.15em] mt-1 ${c.hero ? "text-white" : "text-[#0d1724]/60"}`}>{c.label}</div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
